import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

import g from '#core/global';
import load from '#core/load';
import filter from '#component/filter/filter';


const any_field_$ = 'input';
const show_invalid_c = 'show-invalid';
const date_field_$ = '.field.datepicker input';
const datepicker_hide_delay = 250;

let has_datepicker = false;
let $datepickers = null;


const module = {
	date_field_$: date_field_$,
	
	// This is commented out to avoid circular dependencies
	// datepicker_$: '.air-datepicker',
	
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('field')) return false;
		
		load.content(() => {
			has_datepicker = assign_elements();
			if (!has_datepicker) return false;
		});
		load.all(() => {
			has_datepicker = assign_elements();
			if (!has_datepicker) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_datepicker) return true;
	
	// Highlight invalid fields on blur
	document.querySelectorAll(any_field_$).forEach($field => {
		$field.addEventListener(g.blur_e, () => {
			$field.classList.add(show_invalid_c);
		});
	});
	
	$datepickers = document.querySelectorAll(date_field_$);
	if ($datepickers) {
		$datepickers.forEach($datepicker => {
			init_datepicker($datepicker);
		});
	}
	
	return true;
}


/**
 * Initialize datepicker
 * @param {element} $datepicker
 */
function init_datepicker($datepicker) {
	new AirDatepicker($datepicker, {
		locale: localeEn,
		onShow: (isFinished) => {
		},
		onHide: (isFinished) => {
		},
		onSelect: ({datepicker}) => {
			setTimeout(() => {
				document.dispatchEvent(new CustomEvent(filter.request_e, {
					detail: {
						$source: $datepicker,
					},
				}));
				datepicker.hide();
			}, datepicker_hide_delay);
		},
	});
}
